<div mat-dialog-title>
  <h1>{{ data.title }}</h1>
</div>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onDismiss()">{{ data.btnCancelText }}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">{{ data.btnOkText }}</button>
</div>
